import { render, staticRenderFns } from "./update_log.vue?vue&type=template&id=27127142&scoped=true"
import script from "./update_log.vue?vue&type=script&lang=js"
export * from "./update_log.vue?vue&type=script&lang=js"
import style0 from "./update_log.vue?vue&type=style&index=0&id=27127142&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27127142",
  null
  
)

export default component.exports